// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_1g-6";
export var headerCell = "_1g-2";
export var rowWrapper = "_1g-4";
export var stickyAggregationCell = "_1g-a";
export var stickyAggregationRow = "_1g-7";
export var stickyColumnCell = "_1g-9";
export var stickyColumnHeaderCell = "_1g-8";
export var table = "_1g-1";
export var virtualRowWrapper = "_1g-5";
export var virtualTableContainer = "_1g-0";
export var white = "_1g-3";